"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("@mui/material/styles");
var useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
var BottomNav_1 = __importDefault(require("./BottomNav"));
var NavbarTop_1 = __importDefault(require("./NavbarTop"));
var SearchProduct_1 = __importDefault(require("./SearchProduct"));
function Navbar(props) {
    var theme = (0, styles_1.useTheme)();
    var isSmallScreen = (0, useMediaQuery_1.default)(theme.breakpoints.down("sm"));
    return (react_1.default.createElement(react_1.default.Fragment, null, isSmallScreen ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(SearchProduct_1.default, null),
        " ",
        react_1.default.createElement(BottomNav_1.default, { iconNumber: props.iconNumber }),
        " ")) : (react_1.default.createElement(NavbarTop_1.default, null))));
}
exports.default = Navbar;
